<template>
  <div class="groupContainer">
    <div>
      <div
        v-for="(group, index) in groups"
        :key="index+'facility group'"
        class="d-flex align-items-center">
        <div class="w-100 ">
          <div class="d-flex justify-content-between align-items-center">
            <span class="labelForSelect">{{ questionLabel }} {{ groups.length > 1 ? index + 1 : ''  }}</span>
            <a v-if="showBtnGroup && !isSelectDisabled" role="button" @click="removeGroup(index)" class="btn-remove-group mb-1">Remove</a>
          </div>
          <FacetedSearch
            v-if="!group.isAnotherFacility"
            :options="facetedSearchOptions"
            @search="setFacetedFilters"
            :showOptions="true"
            :optionsToShow="formattedOptions"
            @onSelectOption="onSelectOption"
            :itemIndex="index"
            @clear="onClearFacetedSearch"
            :disabled="isSelectDisabled"
          />
          <!-- <v-select
            v-if="!group.isAnotherFacility"
            v-model="group.facility"
            :options="formattedOptions"
            :filterable="false"
            :multiple="false"
            :clearable="true"
            ref="selectable"
            :placeholder="$t(placeholderTranslation)"
            @search="onSearch"
            @input="onChangeSelect(index)"
            class="w-100"
            :disabled="isSelectDisabled"
          >
            <template #list-footer>
              <li v-if="meta.total > 10" class="pagination">
                <BButton
                  variant="outline-primary"
                  size="sm"
                  :disabled="!hasPrevPage"
                  @click="prevPage"
                >
                  <feather-icon icon="ChevronLeftIcon" size="16"/>
                </BButton>
                <BButton
                  variant="outline-primary"
                  size="sm"
                  :disabled="!hasNextPage"
                  @click="nextPage"
                >
                  <feather-icon icon="ChevronRightIcon" size="16"/>
                </BButton>
              </li>
            </template>
          </v-select> -->
          <b-form-group
            v-else
            class="labelForSelect"
            :label="$t('operational_security.prefill.another_facility')">
            <b-form-input
              id="another_facility"
              v-model="group.anotherFacility"
              :disabled="isSelectDisabled"
              @input="onChangeAnotherFacility(index)"
            />
          </b-form-group>
          <b-form-checkbox
              :id="uniqueId+'isAnotherFacility'+index"
              v-model="group.isAnotherFacility"
              name="isAnotherFacility"
              :value="1"
              class="text-capitalize my-1 cursor-pointer"
              :unchecked-value="0"
              :disabled="isSelectDisabled"
              @input="onChangeIsAnotherFacility(index)"
            >
              {{ $t("operational_security.prefill.another_facility") }}
            </b-form-checkbox>
          <div class="" v-if="!group.isAnotherFacility">
            <b-form-group
              class="labelForSelect ml-1 w-50"
              label="Nombre">
              <b-form-input
                id="name_facility"
                :value="group.facility ? group.facility.label : ''"
                disabled
              />
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.sirh"
              class="labelForSelect ml-1 w-50"
              label="SIRH">
              <b-form-input
                id="sirh_facility"
                v-model="group.sirh"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.rems"
              class="labelForSelect ml-1 w-50"
              label="REMS">
              <b-form-input
                id="rems_facility"
                v-model="group.rems"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.id_seproban"
              class="labelForSelect ml-1 w-50"
              label="ID SEPROBAN">
              <b-form-input
                id="subregion_facility"
                v-model="group.id_seproban"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.categories"
              class="labelForSelect mt-1 ml-1 w-50"
              label="Categorías">
              <b-form-input
                id="categorias_facility"
                v-model="group.categories"
                :disabled="isSelectDisabled"
              />
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.region"
              class="labelForSelect ml-1 w-50"
              label="Estado">
              <b-form-input
                id="region_facility"
                v-model="group.region"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.municipality"
              class="labelForSelect ml-1 w-50"
              label="Municipio">
              <b-form-input
                id="sirh_facility"
                v-model="group.municipality"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.subregion"
              class="labelForSelect ml-1 w-50"
              label="Subregión">
              <b-form-input
                id="subregion_facility"
                v-model="group.subregion"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.lat"
              class="labelForSelect ml-1 w-50"
              label="Latitud ">
              <b-form-input
                id="subregion_facility"
                v-model="group.lat"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.lng"
              class="labelForSelect ml-1 w-50"
              label="Longitud ">
              <b-form-input
                id="subregion_facility"
                v-model="group.lng"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
            </b-form-group>
          </div>
          <hr>
        </div>
      </div>
    </div>
    <button
      v-if="showBtnGroup && !isSelectDisabled"
      @click="addGroup"
      class="addGroupBtn mt-1"
      type="button" >
        <span>+ Instalacion</span>
    </button>
  </div>
</template>

<script>
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import axios from "@axios";
import {debounce} from "lodash";
import vSelect from "vue-select";
import router from "@/router";
import {
  BAU_COMPLEMENTS_QUERY_KEY,
  hasBauComplementsQueryFlag,
  hasBauComplementsUnitQueryValue,
} from "@/utils/bauFormQuery";
import FacetedSearch from "@/components/FacetedSearch.vue";

export default {
  components: {
    vSelect,
    FacetedSearch
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    context: Object
  },
  setup(props, {}) {
    const facetedSearchOptions = [
      {
        label: 'Nombre',
        value: 'description',
        isArray: false,
      },
      {
        label: 'Categoría',
        value: 'category_ss',
        isArray: false,
      },
      {
        label: 'Rems',
        value: 'rems',
        isArray: false,
      },
      {
        label: 'SIRH',
        value: 'sirh',
        isArray: false,
      },
      {
        label: 'Dirección',
        value: 'address_1',
        isArray: false,
      },
        {
          label: 'C.P.',
          value: 'postal_code',
          isArray: false,
        },
      {
        label: 'ID SEPROBAN',
        value: 'id_seproban',
        isArray: false,
      },
      {
        label: 'IP VPN',
        value: 'ip_vpn',
        isArray: false,
      },
    ];
    const extraFieldsDefault = {
      categories: true,
      region: true,
      subregion: true,
      sirh: true,
      municipality: true,
      rems: true,
      id_seproban: true,
      lat: true,
      lng: true,
      excluded_atms: false
    }
    const extraFieldsConf = props?.fieldOptions?.fieldTypeCfg?.data[0] ?? extraFieldsDefault;

    const entity = 'Facility';
    const endpoint = '/v1/unit';
    const mapOptions = (item) => ({
      value: item.id,
      label: `${item.sirh ?? ''}-${item.description}`,
      categories: [item?.category],
      region: item?.region?.name,
      subregion: item?.sector?.name,
      sirh: item?.sirh,
      municipality: item?.municipality?.name,
      rems: item?.rems,
      id_seproban: item?.id_seproban,
      lat: item?.lat,
      lng: item?.lng,
    });
    const placeholderTranslation = 'custom_forms.select_facility';
    const defaultFacilityData = {
      facility: null,
      categories: null,
      region: null,
      subregion: null,
      sirh: null,
      municipality: null,
      rems: null,
      id_seproban: null,
      isAnotherFacility: false,
      anotherFacility: "",
      lat: null,
      lng: null,
    }
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
    const groups = ref([{...defaultFacilityData}]);

    // Pagination
    const search = ref('');
    const limit = ref(8);
    const currentPage = ref(1);
    const meta = ref(null);
    const options = ref([]);
    const isSelectDisabled = ref(false);
    const showBtnGroup = ref(false);
    const facetedFilters = ref({});
    const exFields = props.context.attributes.extraFields
    const questionLabel = props.context.attributes.extraFields.questionLabel
    const hasBauComplementsQuery = () =>
      hasBauComplementsQueryFlag(router.currentRoute?.query || {});
    const hasBauComplementsUnitQuery = () =>
      hasBauComplementsUnitQueryValue(router.currentRoute?.query || {});
    const resolveSelectDisabledState = () =>
      (props.context.attributes.disabled ?? false) || hasBauComplementsUnitQuery();

    onMounted(() => {
      isSelectDisabled.value = resolveSelectDisabledState();
      showBtnGroup.value = props?.fieldOptions?.isGroup;
      const unit = props.context.attributes.extraData.unit || {};
      const unitModel = props?.context?.model

      if(unit?.description) {
        groups.value[0] = {
          facility: {value: unit.id, label: unit.description},
          categories: (unit.categories || []).map((c) => c?.name).join(', ') || null,
          region: unit?.region,
          subregion: unit?.subregion,
          sirh: unit?.sirh,
          municipality: unit?.municipality,
          rems: unit?.rems,
          id_seproban: unit?.id_seproban,
          isAnotherFacility: false,
          anotherFacility: "",
          lat: unit?.lat,
          lng: unit?.lng,
        };
        const modelValue = getModelValue()
        props.context.model =  modelValue.length ? modelValue : null;
      }
      if(unitModel.length) {
        setFacilityValues(unitModel)
        const modelValue = getModelValue()
        props.context.model = modelValue;
      }
      if(exFields?.facilityAnswer?.length) {
        replaceFacility()
      }

      // fetchData();
    });

    function replaceFacility() {
      const data = !showBtnGroup.value && exFields.facilityAnswer.length > 1
      ? exFields.facilityAnswer.slice(0, 1)
      : exFields.facilityAnswer;
      const newData = data.map(obj => {
        const newObj = {};
        const firstKey = Object.keys(obj)[0];
        const oldName = firstKey.split(' [')[0];
        for (const [key, val] of Object.entries(obj)) {
          const updatedKey = key.replace(oldName, exFields.self);
          newObj[updatedKey] = val;
        }
        return newObj;
      });
      if(!newData.length) return;
      setFacilityValues(newData)
      const model = getModelValue()
      props.context.model = model
    }

    async function fetchData() {
      try {
        const params = {
          q: search.value,
          max: limit.value,
          'page[n]': currentPage.value,
          sortBy: 'id',
          'with[]': 'municipality',
          ...facetedFilters.value,
        };
        if (hasBauComplementsQuery()) {
          params.bauVisits = true;
        }
        if (extraFieldsConf?.excluded_atms) {
          params.excludedAtms = true;
        }
        const {data} = await axios.get(endpoint, {
          params,
        });
        meta.value = data.meta;
        options.value = data.data;
      } catch (error) {
        console.error(`${entity}Select: request error`, error?.response || error);
      }
    }

    // Computed properties
    const formattedOptions = computed(() => {
      return (options.value || [])
        .slice()
        .map(mapOptions);
    });

    const hasNextPage = computed(() => {
      return meta.value ? meta.value.current_page < meta.value.last_page : false;
    });

    const hasPrevPage = computed(() => {
      return meta.value ? meta.value.current_page - 1 > 0 : false;
    });

    // Watchers
    watch(currentPage, fetchData);
    watch(
      () => props.context.attributes.disabled,
      () => {
        isSelectDisabled.value = resolveSelectDisabledState();
      },
      { immediate: true }
    );
    watch(
      () => router.currentRoute?.query?.[BAU_COMPLEMENTS_QUERY_KEY],
      () => {
        isSelectDisabled.value = resolveSelectDisabledState();
      }
    );
    watch(
      () => props.context.model,
      (newValue, oldValue) => {
        if(newValue) {
          setFacilityValues(newValue)
        }
      },
      { immediate: true }
    );

    // Methods
    function onChangeSelect(index) {
      const group = groups.value[index]
      const facility = group.facility || {}

      group.categories =
        (facility.categories || []).map(c => c?.name).join(', ') || null

      group.region = facility.region
      group.subregion = facility.subregion
      group.sirh = facility.sirh
      group.municipality = facility.municipality
      group.rems = facility.rems
      group.id_seproban = facility.id_seproban
      group.lat = facility?.lat
      group.lng = facility?.lng

      group.facility = {
        label: facility.label,
        value: facility.value
      }

      const model = getModelValue()
      props.context.model = model.length ? model : null
    }

    function onChange() {
      const model = getModelValue()
      props.context.model = model.length ? model : null
    }

    function setFacilityValues(data) {
      if(!data) return;
      const modelToShow = !showBtnGroup.value && data.length > 1
      ? data.slice(0, 1)
      : data;
      groups.value = modelToShow.map(item => ({
        facility: item[exFields.self] || null,
        categories: item[exFields.categories] ?? null,
        region: item[exFields.region] ?? null,
        subregion: item[exFields.subregion] ?? null,
        sirh: item[exFields.sirh] ?? null,
        municipality: item[exFields.municipality] ?? null,
        rems: item[exFields.rems] ?? null,
        id_seproban: item[exFields.id_seproban] ?? null,
        anotherFacility: item?.anotherFacility ?? "",
        isAnotherFacility: item?.isAnotherFacility ?? false,
        lat: item?.[exFields.lat] ?? null,
        lng: item?.[exFields.lng] ?? null,
      }));
    }

    function getModelValue() {
      const region = groups.value[0].region
      props.context.attributes.updateRegionFromFacility(region);
      props.context.attributes.updateFacility(groups.value[0]);
      return groups.value.map(item => {
        const model = {
          [exFields.self]: {
            label: item.facility?.label,
            value: item.facility?.value
          }
        }

        const map = {
          categories: exFields.categories,
          region: exFields.region,
          subregion: exFields.subregion,
          sirh: exFields.sirh,
          municipality: exFields.municipality,
          rems: exFields.rems,
          id_seproban: exFields.id_seproban,
          isAnotherFacility: "isAnotherFacility",
          anotherFacility: "anotherFacility",
          lat: exFields.lat,
          lng: exFields.lng,
          id: exFields.id,
          name: exFields.name,
        }

        Object.keys(map).forEach(key => {
          if (extraFieldsConf[key] === true && key in item) {
            model[map[key]] = item[key]
          }
          if(key === "isAnotherFacility" || key === "anotherFacility") {
            model[key] = item[key]
          }
          if(key === "id") {
            model[exFields.id] = item?.facility?.value
          }
          if(key === "name") {
            model[exFields.name] = item?.facility?.label
          }
        })
        return model
      })
    }

    function addGroup() {
      groups.value.push({...defaultFacilityData})
      props.context.model = null
    }

    function removeGroup(index) {
      groups.value.splice(index, 1);
      const modelValue = getModelValue()
      props.context.model =  modelValue.length ? modelValue : null;
    }

    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        currentPage.value = 1;
        await fetchData();
        loading(false);
      } else {
        currentPage.value = 1;
        search.value = '';
        await fetchData();
      }
    }, 500);

    function nextPage() {
      currentPage.value += 1;
    }

    function prevPage() {
      currentPage.value -= 1;
    }

    function onChangeAnotherFacility(index) {
      groups.value[index].facility = {value: null, label: groups.value[index].anotherFacility}
      onChange()
    }
    function onChangeIsAnotherFacility(index) {
      groups.value[index].categories = null;
      groups.value[index].region = null;
      groups.value[index].subregion = null;
      groups.value[index].sirh = null;
      groups.value[index].municipality = null;
      groups.value[index].rems = null;
      groups.value[index].id_seproban = null;
      groups.value[index].facility = null;
      groups.value[index].anotherFacility = null;
      groups.value[index].lat = null;
      groups.value[index].lng = null;
    }

    const setFacetedFilters = (filters) => {
      facetedFilters.value = {...filters, ...{advanced_search: true}}
      fetchData();
    };

    const onSelectOption = (val, index) => {
      if(!val) return;
      groups.value[index].facility = val;
      onChangeSelect(index)
    };

    const onClearFacetedSearch = () => {
      groups.value = [{...defaultFacilityData}];
    };

    return {
      formattedOptions,
      meta,
      placeholderTranslation,
      isSelectDisabled,
      hasNextPage,
      hasPrevPage,
      onSearch,
      groups,
      questionLabel,
      showBtnGroup,
      extraFieldsConf,
      uniqueId,
      facetedSearchOptions,
      nextPage,
      prevPage,
      onChange,
      addGroup,
      removeGroup,
      onChangeSelect,
      onChangeAnotherFacility,
      onChangeIsAnotherFacility,
      setFacetedFilters,
      onSelectOption,
      onClearFacetedSearch
    }
  }
}
</script>

<style scoped lang="scss">
.dark-layout {
  .labelForSelect {
    color: #fff
  }
  .addGroupBtn {
    border-color: #fff;
  }
}
.addGroupBtn {
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.65em;
  margin: 0;
  border-color: #53dac5;
  background-color: #53dac5;
  cursor: pointer;
  font-size: 0.75em;
  color: #fff;
  font-weight: bold;
}
.labelForSelect {
  display: block;
  line-height: 1.5;
  font-size: 0.9em;
  font-weight: 600;
  color: #5e5873;
  text-transform: none !important;
  margin-bottom: 0.4em;
}
.groupContainer {
  padding: 1em;
  // border: 1px solid #efefef;
  border-radius: 0.3em;
}
</style>
